import { useSelector } from 'react-redux';
import { selectCurrentUser } from '@features/auth/slice';
import type { User } from '@features/auth/types';

export function useCurrentUser(): User | null {
  return useSelector(selectCurrentUser);
}
